import { render, staticRenderFns } from "./ListOfSko.vue?vue&type=template&id=18d56a64&"
import script from "./ListOfSko.vue?vue&type=script&lang=js&"
export * from "./ListOfSko.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports